// IANA timezones grouped for use in a <select>. Canadian zones first because
// WyseTribe is a Canadian tax service, then the most common global zones.
export const TIMEZONE_GROUPS = [
  {
    label: 'Canada',
    zones: [
      { value: 'America/St_Johns',   label: 'Newfoundland (St. John\'s)' },
      { value: 'America/Halifax',    label: 'Atlantic (Halifax)' },
      { value: 'America/Toronto',    label: 'Eastern (Toronto / Ottawa / Montréal)' },
      { value: 'America/Winnipeg',   label: 'Central (Winnipeg / Regina)' },
      { value: 'America/Regina',     label: 'Central no-DST (Saskatchewan)' },
      { value: 'America/Edmonton',   label: 'Mountain (Edmonton / Calgary)' },
      { value: 'America/Vancouver',  label: 'Pacific (Vancouver)' },
      { value: 'America/Whitehorse', label: 'Yukon (Whitehorse)' },
    ],
  },
  {
    label: 'United States',
    zones: [
      { value: 'America/New_York',    label: 'Eastern (New York)' },
      { value: 'America/Chicago',     label: 'Central (Chicago)' },
      { value: 'America/Denver',      label: 'Mountain (Denver)' },
      { value: 'America/Phoenix',     label: 'Mountain no-DST (Phoenix)' },
      { value: 'America/Los_Angeles', label: 'Pacific (Los Angeles)' },
      { value: 'America/Anchorage',   label: 'Alaska (Anchorage)' },
      { value: 'Pacific/Honolulu',    label: 'Hawaii (Honolulu)' },
    ],
  },
  {
    label: 'Latin America',
    zones: [
      { value: 'America/Mexico_City',    label: 'Mexico City' },
      { value: 'America/Bogota',         label: 'Bogotá / Lima' },
      { value: 'America/Caracas',        label: 'Caracas' },
      { value: 'America/Santiago',       label: 'Santiago' },
      { value: 'America/Sao_Paulo',      label: 'São Paulo' },
      { value: 'America/Buenos_Aires',   label: 'Buenos Aires' },
    ],
  },
  {
    label: 'Europe',
    zones: [
      { value: 'Europe/London',  label: 'London' },
      { value: 'Europe/Dublin',  label: 'Dublin' },
      { value: 'Europe/Paris',   label: 'Paris' },
      { value: 'Europe/Madrid',  label: 'Madrid' },
      { value: 'Europe/Berlin',  label: 'Berlin' },
      { value: 'Europe/Rome',    label: 'Rome' },
      { value: 'Europe/Lisbon',  label: 'Lisbon' },
      { value: 'Europe/Athens',  label: 'Athens' },
      { value: 'Europe/Moscow',  label: 'Moscow' },
    ],
  },
  {
    label: 'Asia / Pacific',
    zones: [
      { value: 'Asia/Dubai',         label: 'Dubai' },
      { value: 'Asia/Karachi',       label: 'Karachi' },
      { value: 'Asia/Kolkata',       label: 'India (Kolkata)' },
      { value: 'Asia/Bangkok',       label: 'Bangkok' },
      { value: 'Asia/Ho_Chi_Minh',   label: 'Ho Chi Minh' },
      { value: 'Asia/Singapore',     label: 'Singapore' },
      { value: 'Asia/Hong_Kong',     label: 'Hong Kong' },
      { value: 'Asia/Shanghai',      label: 'China (Shanghai)' },
      { value: 'Asia/Tokyo',         label: 'Tokyo' },
      { value: 'Asia/Seoul',         label: 'Seoul' },
      { value: 'Australia/Sydney',   label: 'Sydney' },
      { value: 'Pacific/Auckland',   label: 'Auckland' },
    ],
  },
  {
    label: 'Africa',
    zones: [
      { value: 'Africa/Cairo',        label: 'Cairo' },
      { value: 'Africa/Johannesburg', label: 'Johannesburg' },
      { value: 'Africa/Lagos',        label: 'Lagos' },
      { value: 'Africa/Nairobi',      label: 'Nairobi' },
    ],
  },
  { label: 'Other', zones: [{ value: 'UTC', label: 'UTC' }] },
];

export const ALL_TIMEZONE_VALUES = TIMEZONE_GROUPS.flatMap((g) => g.zones.map((z) => z.value));

export const DEFAULT_TIMEZONE = 'America/Edmonton';
